var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5231 0.748047C18.0868 0.748047 0.867432 18.1431 0.867432 39.4038C0.867432 60.6644 18.2625 78.0595 39.5231 78.0595C60.9595 78.0595 78.1789 60.6644 78.1789 39.4038C78.1789 18.1431 60.9595 0.748047 39.5231 0.748047Z",
    fill: "#F59B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3051 22.1922C25.3747 20.1915 28.6743 20.2475 30.675 22.3171L39.5233 31.4705L48.3716 22.3171C50.3722 20.2475 53.6718 20.1915 55.7414 22.1922C57.811 24.1928 57.867 27.4924 55.8663 29.562L46.7724 38.9696L55.8663 48.3771C57.867 50.4467 57.811 53.7463 55.7414 55.747C53.6718 57.7476 50.3722 57.6917 48.3716 55.622L39.5233 46.4686L30.675 55.622C28.6743 57.6917 25.3747 57.7476 23.3051 55.747C21.2355 53.7463 21.1796 50.4467 23.1802 48.3771L32.2742 38.9696L23.1802 29.562C21.1796 27.4924 21.2355 24.1928 23.3051 22.1922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon_x.67ad16139b6e726ce0309b8ccd2925b4.svg";
export { ForwardRef as ReactComponent };